import { useState, useCallback } from "react";

import { validateProduct } from "../Utils/productValidation";
import { buildProductFormData } from "../Utils/productFormData";
import { getUserListByCategory } from "../../../../../redux/services/User Services/User.Services";
import { getProductConfig } from "../Config/getProductConfig";

const initialState = {
    // id: "",
    user_id: "",
    product_name: "",
    category_id: "",
    subcategory_id: "",
    brand_id: "",
    unit_id: "",
    purchase_price: "",
    selling_price: "",
    mrp: "",
    gst_percentage: "",
    hsn_code: "",

    description: "",
    images: [],
    min_stock_level: "",
    reorder_level: "",
    discount_type: "",
    discount: "",
    batch_number: "",
    expiry_date: "",
    subcategory_slug: "",
    service_duration: "",
    service_type: "",
    color_ids: [],
    size_ids: [],
    variants: [],
    material_ids: [],
    // items: [],
    pattern_ids: [],
    model: "",
    ram: "",
    storage: "",
    imei: "",
    warranty: "",
    style_id: "",
    sku: "",
    gender_id: "",
    barcode: "",
    season_id: "",
    status: 1,
};

export default function useProductForm() {
    const [editIndex, setEditIndex] = useState(null);
    // const [items, setItems] = useState([]);
    const [formData, setFormData] = useState(initialState);
    const [selectedSubCategorySlug, setSelectedSubCategorySlug] = useState("");
    // const [imagePreview, setImagePreview] = useState("");
       const [imagePreview, setImagePreview] = useState([]); 
    const [categoryUsers, setCategoryUsers] = useState([]);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [variants, setVariants] = useState([]);

    const [editVariantIndex, setEditVariantIndex] = useState(null);
    // const handleChange = useCallback((e) => {handleVariantSelect 

    //     const { name, value, files, type } = e.target;


    //     if (type === "file") {

    //         const file = files[0];

    //         setFormData((prev) => ({

    //             ...prev,

    //             [name]: file,

    //         }));
    //         if (file) {

    //             setImagePreview(URL.createObjectURL(file));

    //         }

    //     } else {

    //         setFormData((prev) => ({

    //             ...prev,

    //             [name]: value,

    //         }));

    //     }

    //     if (errors[name]) {

    //         setErrors((prev) => ({

    //             ...prev,

    //             [name]: "",

    //         }));

    //     }

    // }, [errors]);

    const handleChange = useCallback((e) => {

        const { name, value, files, type, multiple } = e.target;
         console.log("Typing =>", name, value);
        // if (name.startsWith('variants.')) {
        //     const parts = name.split('.');
        //     const index = parseInt(parts[1]);
        //     const field = parts[2];

        //     setFormData(prev => {
        //         const newVariants = [...(prev.variants || [])];
        //         if (!newVariants[index]) {
        //             newVariants[index] = {};
        //         }
        //         newVariants[index] = {
        //             ...newVariants[index],
        //             [field]: type === 'file' ? files[0] : value
        //         };
        //         return {
        //             ...prev,
        //             variants: newVariants
        //         };
        //     });

        //     if (errors[name]) {
        //         setErrors(prev => ({ ...prev, [name]: "" }));
        //     }
        //     return;
        // }
        if (name.startsWith("variants.")) {

            const parts = name.split(".");
            const index = Number(parts[1]);
            const field = parts[2];

            setFormData(prev => {

                const variants = [...prev.variants];

                variants[index] = {
                    ...variants[index],
                    [field]: value
                };

                return {
                    ...prev,
                    variants
                };

            });

            return;
        }
        if (type === "file") {
            if (multiple) {
                const selectedFiles = Array.from(files);
                setFormData(prev => ({
                    ...prev,
                    images: selectedFiles
                }));

                setImagePreview(
                    selectedFiles.map(file => URL.createObjectURL(file))
                );

            } else {

                const file = files[0];

                setFormData(prev => ({
                    ...prev,
                    images: [file]
                }));

                setImagePreview(
                    file ? [URL.createObjectURL(file)] : []
                );
            }

        } else {

        setFormData(prev => {

            // 👇 Ye code use karo
            const updated = {
                ...prev,
                [name]: value
            };

            console.log("Updated FormData =>", updated);

            return updated;
        });
    }

    }, [errors]);
    // ✅ NAYA FUNCTION: Vendor ke liye auto-fill
    const handleVendorCategoryChange = async (
        vendorCategory,
        loadSubCategory,
        loadDynamicDropdowns
    ) => {
        if (!vendorCategory) return;

        const categoryId = vendorCategory.category_id;
        const subCategoryId = vendorCategory.subcategory_id;
        const subCategorySlug = vendorCategory.subcategory_slug;

        const config = getProductConfig(subCategorySlug);
        const hasVariants = config?.components?.variants === true;

        // ✅ CREATE INITIAL VARIANT DYNAMICALLY
        const variantConfig = config?.variant_fields || { required: [], optional: [] };
        const allVariantFields = [...variantConfig.required, ...variantConfig.optional];

        const initialVariant = {};
        allVariantFields.forEach(field => {
            if (field === 'color_ids' || field === 'size_ids') {
                initialVariant[field] = [];
            } else {
                initialVariant[field] = "";
            }
        });

        // ✅ Load dropdowns
        await loadSubCategory(categoryId);
        await loadDynamicDropdowns({
            category_id: categoryId,
            subcategory_id: subCategoryId,
        });

        // ✅ Set formData
        setFormData((prev) => ({
            ...prev,
            category_id: categoryId,
            subcategory_id: subCategoryId,
            subcategory_slug: subCategorySlug,
            variants: hasVariants ? [initialVariant] : []
        }));
    };

    const createVariantObject = (slug) => {

        const config = getProductConfig(slug);

        const variantConfig = config?.variant_fields || {
            required: [],
            optional: []
        };

        const fields = [
            ...variantConfig.required,
            ...variantConfig.optional
        ];

        const variant = {};

        fields.forEach(field => {

            if (field === "color_ids" || field === "size_ids") {
                variant[field] = [];
            }
            // else if (field === "image") {
            //     variant[field] = null;   // 👈 image ke liye
            // }
            else {
                variant[field] = "";
            }

        });
        return variant;
    };
    const handleNumberInput = useCallback((e) => {

        const { name, value } = e.target;

        const numericValue = value.replace(/[^0-9.]/g, "");

        setFormData((prev) => ({

            ...prev,

            [name]: numericValue,

        }));

    }, []);

    const handleCategoryChange = useCallback(async (e, loadSubCategory) => {
        const categoryId = e.target.value;
        setFormData(prev => ({
            ...prev,
            category_id: categoryId,
            subcategory_id: ""
        }));
        await loadSubCategory(categoryId);
    }, []);
    // const handleSelectChange = (name, selectedOptions) => {
    //     setFormData(prev => ({

    //         ...prev,

    //         [name]: selectedOptions
    //             ? selectedOptions.map(item => item.value)
    //             : []

    //     }));

    // };


    const handleSelectChange = useCallback((index, name, selectedOptions) => {

        setFormData(prev => {

            const variants = [...prev.variants];

            if (!variants[index]) {
                variants[index] = {};
            }

            if (name === "color_ids") {

                variants[index].color_ids = selectedOptions
                    ? selectedOptions.map(x => x.value)
                    : [];

                variants[index].attribute_name = "Color";
                variants[index].attribute_value = selectedOptions?.[0]?.label || "";
                variants[index].attribute_value_id = selectedOptions?.[0]?.value || "";
            }

            if (name === "size_ids") {

                variants[index].size_ids = selectedOptions
                    ? selectedOptions.map(x => x.value)
                    : [];
            }

            return {
                ...prev,
                variants
            };

        });

    }, []);

    // const createFormData = useCallback(() => {

    //     return buildProductFormData(formData);

    // }, [formData]);


    const createFormData = useCallback(() => {

        const config = getProductConfig(formData.subcategory_slug);

        return buildProductFormData(formData, config);

    }, [formData]);

    const validate = useCallback(() => {
        const config = getProductConfig(formData.subcategory_slug);
        const validation = validateProduct(formData, config);
        setErrors(validation.errors);
        return validation.valid;
    }, [formData]);
    const resetForm = useCallback(() => {
        const config = getProductConfig(formData.subcategory_slug);
        const hasVariants = config?.components?.variants === true;

        // ✅ CHANGE: Get variant fields from config
        const variantConfig = config?.variant_fields || { required: [], optional: [] };
        const allVariantFields = [...variantConfig.required, ...variantConfig.optional];

        // ✅ CHANGE: Create initial variant dynamically
        const initialVariant = {};
        allVariantFields.forEach(field => {
            if (field === 'color_ids' || field === 'size_ids') {
                initialVariant[field] = [];
            }
            // else if (field === "image") {
            //     initialVariant[field] = null;
            // }
            else {
                initialVariant[field] = "";
            }
        });

        setFormData({
            ...initialState,
            variants: hasVariants ? [initialVariant] : []
        });
        setImagePreview([]);
        setErrors({});
    }, [formData.subcategory_slug]);

    const addVariant = () => {

        const newVariant = createVariantObject(formData.subcategory_slug);

        setFormData(prev => ({
            ...prev,
            variants: [...prev.variants, newVariant]
        }));
    };
    const deleteVariant = (index) => {
        setFormData(prev => ({
            ...prev,
            variants: prev.variants.filter((_, i) => i !== index)
        }));
        if (editVariantIndex === index) {
            setEditVariantIndex(null);
            const config = getProductConfig(formData.subcategory_slug);
            const variantConfig = config?.variant_fields || { required: [], optional: [] };
            const fields = [...variantConfig.required, ...variantConfig.optional];
            const resetVariant = {};
            fields.forEach(field => {
                if (field === 'color_ids' || field === 'size_ids') {
                    resetVariant[field] = [];
                }
                // else if (field === "image") {
                //     resetVariant[field] = null;
                // }
                else {
                    resetVariant[field] = "";
                }
            });

        }
    };


    const editVariant = (index) => {
        setEditVariantIndex(index);
    };

    const handleUserChange = async (
        e,
        users,
        loadSubCategory,
        loadDynamicDropdowns
    ) => {
        const userId = e.target.value;

        setFormData((prev) => ({
            ...prev,
            user_id: userId,
        }));

        if (!userId) return;

        try {
            const res = await getUserListByCategory({
                user_id: userId,
            });
            if (!res?.success) return;
            const category = res.data.user_category;
            const subCategorySlug = res.data.user_category.subcategory.slug;
            const config = getProductConfig(subCategorySlug);
            const hasVariants = config?.components?.variants === true;

            // ✅ GET VARIANT FIELDS FROM CONFIG
            const variantConfig = config?.variant_fields || { required: [], optional: [] };
            const allVariantFields = [...variantConfig.required, ...variantConfig.optional];

            // ✅ CREATE INITIAL VARIANT DYNAMICALLY
            const initialVariant = {};
            allVariantFields.forEach(field => {
                if (field === 'color_ids' || field === 'size_ids') {
                    initialVariant[field] = [];
                } else {
                    initialVariant[field] = "";
                }
            });

            await loadSubCategory(category.category_id);
            await loadDynamicDropdowns({
                category_id: category.category_id,
                subcategory_id: category.sub_category_id,
            });

            setFormData((prev) => ({
                ...prev,
                user_id: userId,
                category_id: category.category_id,
                subcategory_id: category.sub_category_id,
                subcategory_slug: subCategorySlug,
                variants: hasVariants ? [initialVariant] : []
            }));

        } catch (error) {
            console.log(error);
        }
    };


const handleVendorAutoFill = async (
    vendorId,
    loadSubCategory,
    loadDynamicDropdowns
) => {
    if (!vendorId) return;

    try {
        // ✅ SAME API jo User select pe chalti thi
        const res = await getUserListByCategory({ user_id: vendorId });
        console.log("📦 user-by-category API Response:", res);

        if (!res?.success || !res.data?.user_category) return;

        const category = res.data.user_category;
        const subCategorySlug = category.subcategory?.slug;
        const categoryId = category.category_id;
        const subCategoryId = category.sub_category_id;

        const config = getProductConfig(subCategorySlug);
        const hasVariants = config?.components?.variants === true;

        const variantConfig = config?.variant_fields || { required: [], optional: [] };
        const allVariantFields = [...variantConfig.required, ...variantConfig.optional];

        const initialVariant = {};
        allVariantFields.forEach(field => {
            if (field === 'color_ids' || field === 'size_ids') {
                initialVariant[field] = [];
            } else {
                initialVariant[field] = "";
            }
        });

        // ✅ Dropdowns load karo
        await loadSubCategory(categoryId);
        await loadDynamicDropdowns({
            category_id: categoryId,
            subcategory_id: subCategoryId,
        });

        // ✅ FormData set karo
        setFormData((prev) => ({
            ...prev,
            user_id: vendorId,
            category_id: categoryId,
            subcategory_id: subCategoryId,
            subcategory_slug: subCategorySlug,
            variants: hasVariants ? [initialVariant] : []
        }));

        console.log("✅ Vendor auto-fill complete:", {
            vendorId, categoryId, subCategoryId, subCategorySlug
        });

    } catch (error) {
        console.error("❌ Vendor auto-fill failed:", error);
    }
};
    const setSelectedSubCategory = (subcategory) => {

        setFormData(prev => ({

            ...prev,

            subcategory_id: subcategory.id,

            subcategory_slug: subcategory.slug

        }));

    };

    const updateSelectedSubCategorySlug = (slug) => {
        setFormData(prev => ({
            ...prev,
            subcategory_slug: slug
        }));
    };

    const handleSpecificationSelect = useCallback((name, selectedOptions, isMulti = true) => {
        let value;
        if (isMulti) {
            // Multi-Select (Colors, Sizes) -> Array of IDs
            value = selectedOptions ? selectedOptions.map(item => item.value) : [];
        } else {
            // Single-Select -> Single ID or value
            value = selectedOptions ? selectedOptions.value : '';
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        // Clear error if exists
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: ""
            }));
        }
    }, [errors]);
    const setCategoryAndSubCategory = async (
        categoryId,
        subCategoryId,
        loadSubCategory
    ) => {

        await loadSubCategory(categoryId);

        setFormData(prev => ({
            ...prev,
            category_id: categoryId,
            subcategory_id: subCategoryId
        }));
    };
    const getFieldLabel = (fieldName) => {
        const labels = {
            sku: 'SKU',
            color_ids: 'Colors',
            size_ids: 'Sizes',
            barcode: 'Barcode',
            model: 'Model',
            ram: 'RAM',
            storage: 'Storage',
            imei: 'IMEI',
            warranty: 'Warranty',
            material: 'Material',
            dimensions: 'Dimensions',
            weight: 'Weight',
            stock: 'Stock',
            price: 'Price'
        };
        return labels[fieldName] || fieldName.replace('_', ' ').toUpperCase();
    };

    const setFormDataValues = useCallback((data) => {
    setFormData(prev => ({
        ...prev,
        ...data
    }));
}, []);

// SET IMAGE PREVIEW - For Edit
const setImagePreviewValues = useCallback((images) => {
    if (Array.isArray(images)) {
        setImagePreview(images);
    } else if (typeof images === 'string') {
        setImagePreview([images]);
    } else {
        setImagePreview([]);
    }
}, []);

// RESET FORM
// const resetForm = useCallback(() => {
//     setFormData(initialState);
//     setImagePreview([]);
//     setErrors({});
// }, []);
    return {
        formData,
        errors,
        imagePreview,
        isLoading,
        setIsLoading,
        // items,
        handleUserChange,
        // addItem,
        handleChange,
        handleNumberInput,
        handleVendorAutoFill,
        selectedSubCategorySlug,

        addVariant,
        deleteVariant,
        editVariant,
        // handleVariantChange,
        // handleVariantSelect,
        handleSpecificationSelect,
        updateSelectedSubCategorySlug,
        setSelectedSubCategory,
        handleCategoryChange,
        handleSelectChange,
        validate,
        setCategoryAndSubCategory,
        createFormData,
        resetForm,
        handleVendorCategoryChange,
  setFormData: setFormDataValues,     // ✅ ADD
    setImagePreview: setImagePreviewValues,

    }
}